import { ClientType } from "src/api/v1/project-ApiSlice";
import { IMAGE_HOST } from "src/utils/constants";

import { Fragment } from "react";
import DOMPurify from "dompurify";

export const Product = (
    props: {
      productKey: number,
      product: any,
      clientType: ClientType
    }
) => {
  const { product, clientType } = props;

  return product &&
  product.descriptions[clientType].desc &&
  product.descriptions[clientType].desc !== "<p><br></p>" ? (
      <Fragment>
        <table width="100%">
          <tbody>
          <tr style={{verticalAlign:'top'}}>
            <td
                style={{
                  width: 150,
                  display:
                      product.image || product.base_image || product.icon
                          ? ""
                          : "none",
                  paddingTop: 0,
                  paddingBottom: 30,
                }}
            >
              <a
                  target="_blank"
                  href={
                    product.icon
                        ? `${IMAGE_HOST}${product.icon}`
                        : ""
                  }
              >
                <div
                    className="product-image"
                    style={{
                      backgroundImage: `url('${
                          product.icon
                              ? `${IMAGE_HOST}${product.icon}`
                              : ""
                      }')`,
                    }}
                ></div>
              </a>
            </td>
            <td
                style={{
                  width: 200,
                  display: product.name ? "" : "none",
                  fontWeight: 600,
                  paddingRight: 30,
                  paddingTop: 20,
                }}
            >
              {product.name}
            </td>
            <td
                style={{
                  display: product.descriptions[clientType].desc ? "" : "none",
                  fontSize: 14,
                }}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(product.descriptions[clientType].desc),
                }}
            />
          </tr>
          </tbody>
        </table>
      </Fragment>
  ) : null;
};
